import { FormControl, FormLabel, Select } from '@chakra-ui/react';

export type Option = {
  value: string | number;
  label: string;
  disabled?: boolean;
};

interface LabeledSelectProps {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  placeholder?: string;
  options: Option[];
  isRequired?: boolean;
}

export const LabeledSelect: React.FC<LabeledSelectProps> = ({
  label,
  value,
  onChange,
  placeholder = 'Escolha a opção',
  options,
  isRequired = true,
}) => (
  <FormControl isRequired={isRequired}>
    <FormLabel fontWeight="semibold">{label}</FormLabel>
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value} disabled={opt.disabled}>
          {opt.label}
        </option>
      ))}
    </Select>
  </FormControl>
);
